export default __webpack_public_path__ + "static/media/terminos.fdc3677e.pdf";